<template>
  <div>
    <ul class="group-list">
      <li v-for="client in clients" :key="client.id">
        <div>
          {{ client.full_name | maxChar(30)  }}
        </div>
        <div>
          <select @change="init" v-model="client.number">
            <option value="1">1 группа</option>
            <option value="2">2 группа</option>
            <option value="3">3 группа</option>
          </select>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data: () => ({

  }),
  watch: {

  },
  computed: {
    ...mapState(["lastUpdate"]),
  },
  props: {
    value: {
      default: function () {
        return [];
      },
    },
    group_id: {
      default: null
    }
  },
  async created() {
    this.$loading(true);
    this.clients = await this.$http.get(`business/groups/${this.group_id}/clients`, { params: { per_page: 200 } }).then(response => {
      return response.data.data;
    }).catch(() => {
      return [];
    }).finally(() => {
      this.$loading(false);
    });

    if (this.value) {


      for (let i = 0; i < this.clients.length; i++) {
        if (this.value[this.clients[i]['id']]) {
          this.$set(this.clients, i, { ...this.clients[i], number: this.value[this.clients[i]['id']] });
        }
        // else {
        //   this.$set(this.clients, i, { ...this.clients[i], number: 1});
        // }
      }
    }
  },
  methods: {
    async init() {
      let value = {};
      for (let i = 0; i < this.clients.length; i++) {
        value[this.clients[i]['id']] = await this.clients[i]['number'];
      }
      this.$emit('input', value);
    }
  },
  data() {
    return {
      clients: []
    }
  },
};
</script>
<style lang="scss">
ul.group-list {
  &>li {
    border-bottom: 1px solid #ebebeb;
    padding: 5px 0;
    display: flex;

    &>div {
      &:last-of-type {
        margin-left: auto;
      }
    }
  }
}
</style>